import { makeStyles } from '@material-ui/core';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    formSpacer: {
        height: '50px',
    },
    formActionContainer: {
        textAlign: 'right',
    },
    formActions: {
        top: 'auto',
        bottom: 0,
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    formActionsButton: {
        marginLeft: theme.spacing(2),
    },
}));
